import { all, takeLatest } from 'redux-saga/effects'

import { RequestActions } from '../actions'
import { attachFile } from './attachFile'
import { fetchAuth } from './fetchAuth'

export function* requestsSaga() {
  yield all([
    takeLatest(RequestActions.attachFile.type, attachFile),
    takeLatest(RequestActions.fetchAuth.type, fetchAuth),
  ])
}
